export default __webpack_public_path__ + "static/media/feed-customization-s1.20b43410.png";